import React, { useState } from 'react'
import { Button } from '../ui/Button'
import { Input } from '../ui/Input'

interface AddAdminDialogProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: (email: string) => void
}

export const AddAdminDialog: React.FC<AddAdminDialogProps> = ({
  isOpen,
  onClose,
  onConfirm
}) => {
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')

  if (!isOpen) return null

  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  const handleSubmit = () => {
    if (!email.trim()) {
      setError('L\'email est requis')
      return
    }
    
    if (!validateEmail(email)) {
      setError('Format d\'email invalide')
      return
    }

    onConfirm(email.trim())
    setEmail('')
    setError('')
    onClose()
  }

  const handleClose = () => {
    setEmail('')
    setError('')
    onClose()
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg p-6 max-w-md w-full mx-4">
        <h3 className="text-lg font-medium mb-4 text-gray-900 dark:text-white">
          Ajouter un administrateur
        </h3>
        
        <div className="mb-4">
          <label htmlFor="admin-email" className="block text-sm font-normal text-gray-700 dark:text-gray-300 mb-2">
            Email <span className="text-red-500">*</span>
          </label>
          <Input
            id="admin-email"
            type="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value)
              setError('')
            }}
            placeholder="exemple@email.com"
            className="w-full"
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleSubmit()
              }
            }}
          />
          {error && (
            <p className="mt-1 text-sm text-red-600 dark:text-red-400">
              {error}
            </p>
          )}
          <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
            L&apos;utilisateur doit déjà avoir un compte pour être ajouté comme administrateur.
          </p>
        </div>

        <div className="flex justify-end gap-4">
          <Button
            variant="outline"
            onClick={handleClose}
          >
            Annuler
          </Button>
          <Button
            variant="primary"
            onClick={handleSubmit}
          >
            Ajouter
          </Button>
        </div>
      </div>
    </div>
  )
}